import AriaControl from "../../../utilities/accessibility/js/AriaControl";
import { _defaultConfigOptions } from "../../../utilities/accessibility/js/constants";

export default class Clear extends AriaControl {
  /**
   * Default config that we control the ARIA attributes with
   */
  static defaultConfigOptions = _defaultConfigOptions;

  constructor({ control }) {
    // Initialise ARIA
    super({ control });

    // Initialise button
    this.control = control;
    this.targets = document.querySelectorAll(
      `[data-controlled-by*=${this.control.id}]`
    );

    // Add event listeners
    this.control.addEventListener("click", this.handleClick.bind(this));
  }

  /**
   * Clear the input
   */
  handleClick() {
    this.targets.forEach((target) => {
      target.value = "";
    });
  }
}
